/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Type_OtherInputs */

const en_us2_bodymap_type_other = /** @type {(inputs: Bodymap_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something else`)
};

const pt_br2_bodymap_type_other = /** @type {(inputs: Bodymap_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outra coisa`)
};

const es_419_bodymap_type_other = /** @type {(inputs: Bodymap_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otra cosa`)
};

const pt_pt2_bodymap_type_other = /** @type {(inputs: Bodymap_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outra coisa`)
};

const fr_fr2_bodymap_type_other = /** @type {(inputs: Bodymap_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre chose`)
};

const de_de2_bodymap_type_other = /** @type {(inputs: Bodymap_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas anderes`)
};

const it_it2_bodymap_type_other = /** @type {(inputs: Bodymap_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro`)
};

/**
* | output |
* | --- |
* | "Something else" |
*
* @param {Bodymap_Type_OtherInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_type_other = /** @type {((inputs?: Bodymap_Type_OtherInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Type_OtherInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_type_other(inputs)
	if (locale === "es-419") return es_419_bodymap_type_other(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_type_other(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_type_other(inputs)
	if (locale === "de-DE") return de_de2_bodymap_type_other(inputs)
	if (locale === "it-IT") return it_it2_bodymap_type_other(inputs)
	return en_us2_bodymap_type_other(inputs)
});
export { bodymap_type_other as "bodymap.type.other" }